import { render, staticRenderFns } from "./CreatesoGin.vue?vue&type=template&id=54f96f02&scoped=true"
import script from "./CreatesoGin.vue?vue&type=script&lang=js"
export * from "./CreatesoGin.vue?vue&type=script&lang=js"
import style0 from "./CreatesoGin.vue?vue&type=style&index=0&id=54f96f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f96f02",
  null
  
)

export default component.exports